export default "__VITE_ASSET__D8M_Zvop__"